import { withAssetPrefix } from 'gatsby';

export default ({ intl }) => [
  {
    url: withAssetPrefix('galeria-empresa/Screenshot_2.png'),
    alt: `${intl.formatMessage({ id: 'Imagem empresa' })} 2`,
    sizes: {
      medium: withAssetPrefix('galeria-empresa/Screenshot_2-225x300.png'),
    },
  },
  {
    url: withAssetPrefix('galeria-empresa/Screenshot_1.png'),
    alt: `${intl.formatMessage({ id: 'Imagem empresa' })} 1`,
    sizes: {
      medium: withAssetPrefix('galeria-empresa/Screenshot_1-300x275.png'),
    },
  },
  {
    url: withAssetPrefix('galeria-empresa/Screenshot_3.png'),
    alt: `${intl.formatMessage({ id: 'Imagem empresa' })} 3`,
    sizes: {
      medium: withAssetPrefix('galeria-empresa/Screenshot_3-300x275.png'),
    },
  },
  {
    url: withAssetPrefix('galeria-empresa/Screenshot_4.png'),
    alt: `${intl.formatMessage({ id: 'Imagem empresa' })} 4`,
    sizes: {
      medium: withAssetPrefix('galeria-empresa/Screenshot_4-300x275.png'),
    },
  },
];